import React from 'react';
import ProcessItemProp from './properties/process-item';
import Utils from '../common/utils';

function ProcessItem({process}: ProcessItemProp): React.ReactElement {
    const status = process.status === 'running' ? 'running' : 'stopped';
    const statusClass = `text-sm-label text-capitalize ${status}`;
    const href = `/jetski/process/?id=${process.id}`;

    return (
        <a
            style={{
                backgroundColor: '#fff', marginBottom: '1rem', padding: '0px', border: '1px solid #eaeaea',
            }}
            href={href}
            className="process-item rounded list-group-item list-group-item-action flex-column align-items-start text-start"
        >
            <div style={{backgroundColor: '#fff5e6', padding: '1rem'}}>
                <div className="d-flex w-100 justify-content-between">
                    <small className="small-label">
                        <span className="sub-title fw-bold">{process.id}</span>
                    </small>
                    <small className={statusClass}>{status}</small>
                </div>
                <small style={{color: "grey"}}>
                    <span className="small-label me-2">
                         <span className=" fw-bold"> Process Id: </span>
                        {process.processID || "Not running"}
                    </span>
                    <span className="small-label me-2">
                         <span className=" fw-bold"> Memory: </span>
                        {((Math.floor(process.monitor?.memory / 1048576)) + "Mb") || "0Mb"}
                    </span>
                    <span className="small-label">
                         <span className=" fw-bold"> CPU: </span>
                        {process.monitor?.cpu || 0}
                    </span>
                </small>
                <p className="mb-1 pt-2 fst-italic">{process.processDescription}</p>
            </div>
            <div style={{backgroundColor: '#fff', padding: '1rem'}}>
                <div className="row">
                    <div className="col-sm-3 mb-2 mt-2">
                        <h6 className="sub-title text-uppercase">Blockchain</h6>
                        <span className="sub-title text-uppercase">{process.blockchain}</span>
                    </div>
                    <div className="col-sm-3 mb-2 mt-2">
                        <h6 className="sub-title text-uppercase">PM2 Process Id/Name</h6>
                        <span className="sub-title">{process.id}</span>
                    </div>
                    <div className="col-sm-3 mb-2 mt-2">
                        <h6 className="sub-title text-uppercase">Last Start Time</h6>
                        <span className="sub-title">{Utils.formatDateString(process.lastStartTime)}</span>
                    </div>
                    <div className="col-sm-3 mb-2 mt-2">
                        <h6 className="sub-title text-uppercase">Last Stop Time</h6>
                        <span className="sub-title">{Utils.formatDateString(process.lastStopTime)}</span>
                    </div>
                </div>
            </div>
        </a>
    );
}

export default ProcessItem;
